import { useEffect } from "react";
import { encrypt } from "../../utils/other";
import { stopLoader } from "../../utils/loaderUtils";

function NativeComponent() {
  useEffect(() => {
    const handleMessage = async (event) => {
      const data = event.data;

      // Handle the received data in your web app
      if (data?.authToken && data?.refreshToken) {
        const authObj = {
          ACCESS_TOKEN: data?.authToken,
          REFRESH_TOKEN: data?.refreshToken,
        };
        const encryptedUserData = encrypt(authObj);
        await localStorage.setItem("user", encryptedUserData);

        if (data?.isReschedule) {
          await localStorage.setItem("isReschedule", data?.isReschedule);
        }

        if (data?.isApp) {
          await localStorage.setItem("isApp", data?.isApp);
        }

        if (data?.userRole) {
          await localStorage.setItem("userRole", data?.userRole);
        }

        if (data?.userId) {
          await localStorage.setItem("userId", data?.userId);
        }

        if (data?.isMobileDummy !== undefined) {
          await localStorage.setItem(
            "isMobileDummy",
            String(data?.isMobileDummy)
          );
        }

        if (data?.students) {
          await window.localStorage.setItem(
            "studentsList",
            JSON.stringify(data?.students)
          );
        }

        if (data?.appVersion) {
          await window.localStorage.setItem("appVersion", data.appVersion);
        }
        stopLoader();
        window.location.href = data.url;
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  });
  return null;
}

export default NativeComponent;
